import { Outlet } from 'react-router-dom'
import { useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useLocation, useNavigate } from 'react-router-dom'
import { FluidProvider, useFluid } from '../../context/FluidContext'
import useAuthStore from '../../store/authStore'
// C8 · unificar la nav: las rutas AppLayout usaban PLTabBar (anclada, labels). Ahora
// la MISMA barra flotante Instagram que el resto de la app (G-UNICIDAD).
import BottomNav, { DEFAULT_ITEMS } from '../../design-system/navigation/BottomNav'
import AuriaFAB from '../ai/AuriaFAB'
import HeaderMenu from './HeaderMenu'
import { applyPhysiologicalTokens } from '../../engine/physiologicalUI'

/**
 * Sprint 8 — AppLayout reescrito sobre Fluid Interface.
 *
 * Cambios clave:
 *  - Envuelve children en <FluidProvider> (espacio fluido único)
 *  - aurIA YA NO está en el tab bar → AuriaCommandOverlay (punto flotante)
 *  - Dock contextual: FluidNav rota items según hora + plan
 *  - Physiological tokens: applyPhysiologicalTokens(vitalLoad) al cargar
 *  - En FULL screen el nav y el overlay se ocultan
 */

function LayoutShell({ children }) {
  const location = useLocation()
  const navigate = useNavigate()
  const { isFullscreen } = useFluid()
  const { profile } = useAuthStore()

  // activeId desde la ruta (canónica o legacy) · null en rutas que no son tab (/mobility…)
  const _seg = (location.pathname || '').split('/')[1] || ''
  const _ROUTE_TO_ID = {
    today: 'today', hub: 'hub',
    calendar: 'calendar', calendario: 'calendar',
    domains: 'domains', dominios: 'domains',
    progress: 'progress', progreso: 'progress',
  }
  const activeId = _ROUTE_TO_ID[_seg] || null

  // Aplica los tokens fisiológicos — defaults to 'normal' profile.
  // Sprint 15: trainingStore removed; vital_load will be wired via /api/today in Ola 2.
  useEffect(() => {
    applyPhysiologicalTokens(undefined)
  }, [])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      maxWidth: 430,
      margin: '0 auto',
      background: 'var(--bg)'
    }}>
      <main style={{ flex: 1, overflowY: 'auto', paddingBottom: isFullscreen ? 0 : 80 }}>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0.7, y: -4 }}
            transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
          >
            {children || <Outlet />}
          </motion.div>
        </AnimatePresence>
      </main>

      {!isFullscreen && (
        <BottomNav
          activeId={activeId}
          onSelect={(id, it) => { if (it?.path) navigate(it.path) }}
        />
      )}
      <AuriaFAB />
      {/* BUG-04: HeaderMenu with logout accessible from any surface */}
      <HeaderMenu />
    </div>
  )
}

export default function AppLayout({ children }) {
  return (
    <FluidProvider>
      <LayoutShell>{children}</LayoutShell>
    </FluidProvider>
  )
}
